import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { isAskDaiNavigation } from "@/components/askdai/navigation";

const getHashId = (hash) => {
  const rawId = hash.slice(1);

  try {
    return decodeURIComponent(rawId);
  } catch {
    return rawId;
  }
};

export default function ScrollToTop() {
  const location = useLocation();
  const { pathname, hash } = location;
  const navigationType = useNavigationType();
  const handled = useRef(null);

  useEffect(() => {
    const previous = handled.current;
    handled.current = { location, navigationType };
    if (previous && isAskDaiNavigation(previous.location, location)) return;
    if (navigationType === "POP") return;
    // Query updates alone did not trigger this handler before dialog history was
    // introduced. Keep that behaviour while remembering every location for Back.
    if (previous && previous.location.pathname === pathname && previous.location.hash === hash
      && previous.navigationType === navigationType) return;

    if (hash) {
      const id = getHashId(hash);
      const timer = window.setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 50);
      return () => window.clearTimeout(timer);
    }

    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location, pathname, hash, navigationType]);

  return null;
}
